import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui';
import { Check, Star, Gift } from 'lucide-react';
const includedItems = ['7 module online, live, câte un weekend pe lună, 7 luni de program structurat', 'Manual dedicat pentru fiecare modul, cu toate tehnicile și exercițiile', '6 sesiuni online între module, câte 3 ore fiecare, pentru clarificări și aplicare practică', '7 meditații audio ghidate cu cele mai importante exerciții NLP', 'Comunitate de suport și învățare pe tot parcursul programului', 'Certificat NLP național și internațional la finalul programului'];
const bonuses = ['Sesiune 1-la-1 cu Marius Cernea — 60 min de breakthrough personal cu un NLP Master', 'Inner Blueprint — 5 Meditații NLP Ghidate: Creativitate, Misiune Personală, Încredere în Sine, Deblocare Obiective, Convingeri Limitative', 'Sesiune VIP de Mentorare de Grup — aprofundare live a conceptelor avansate'];
export const Pricing = () => {
  return <section id="pricing" className="py-24 bg-navy relative overflow-hidden" data-id="element-332">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-purple/10 blur-[120px] pointer-events-none z-0" data-id="element-333" />
      <div className="container mx-auto px-6 relative z-10" data-id="element-334">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-6" data-id="element-335">
          <p className="font-display text-gold text-base font-semibold tracking-widest uppercase mb-4" data-id="element-336">
            Ce primești în program
          </p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-337">
            Tot ce este inclus în NLP Practitioner
          </h2>
          <div className="w-24 h-px bg-gold mx-auto" data-id="element-338" />
        </motion.div>
        {/* Single card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="max-w-3xl mx-auto mt-12" data-id="element-339">
          <div className="bg-navy-card border-2 border-gold flex flex-col relative shadow-2xl shadow-gold/10" data-id="element-340">
            {/* Header */}
            <div className="p-8 md:p-10 text-center border-b border-gold/20 bg-gradient-to-b from-gold/5 to-transparent" data-id="element-341">
              <div className="inline-flex items-center gap-2 bg-gold px-4 py-1.5 mb-5" data-id="element-342">
                <Star className="w-3.5 h-3.5 text-navy-dark fill-navy-dark" data-id="element-343" />
                <span className="font-display text-xs font-bold tracking-widest uppercase text-navy-dark" data-id="element-344">
                  NLP Practitioner
                </span>
              </div>
              <h3 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-345">
                Programul complet — 7 luni de transformare
              </h3>
              <p className="font-sans text-white/70 text-lg" data-id="element-346">
                Disponibil cu plată integrală sau în rate lunare.
              </p>
            </div>
            {/* Features list */}
            <div className="p-8 md:p-10 flex-grow" data-id="element-347">
              <ul className="space-y-5" data-id="element-348">
                {includedItems.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-349">
                    <Check className="w-5 h-5 text-gold shrink-0 mt-1" data-id="element-350" />
                    <span className="font-sans text-white text-xl leading-relaxed" data-id="element-351">
                      {item}
                    </span>
                  </li>)}
              </ul>
              {/* Bonuses */}
              <div className="flex items-center gap-3 my-8" data-id="element-352">
                <div className="flex-grow h-px bg-gold/30" data-id="element-353" />
                <span className="font-display text-xs font-bold tracking-widest uppercase text-gold" data-id="element-354">
                  Bonusuri exclusive — la plata integrală
                </span>
                <div className="flex-grow h-px bg-gold/30" data-id="element-355" />
              </div>
              <ul className="space-y-5" data-id="element-356">
                {bonuses.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-357">
                    <Gift className="w-5 h-5 text-gold shrink-0 mt-1" data-id="element-358" />
                    <div data-id="element-359">
                      <div className="flex items-center gap-2 mb-1" data-id="element-360">
                        <span className="bg-gold text-navy-dark font-display text-[10px] font-bold uppercase tracking-wider px-2 py-0.5" data-id="element-361">
                          Bonus
                        </span>
                      </div>
                      <span className="font-sans text-white text-xl leading-relaxed" data-id="element-362">
                        {item}
                      </span>
                    </div>
                  </li>)}
              </ul>
            </div>
            {/* CTA */}
            <div className="p-8 md:p-10 border-t border-gold/20" data-id="element-363">
              <div className="text-center mb-6" data-id="element-364">
                <p className="font-sans text-white/70 text-lg leading-relaxed" data-id="element-365">
                  Poți plăti <strong className="text-white" data-id="element-366">integral</strong> și
                  primești toate bonusurile, sau în{' '}
                  <strong className="text-white" data-id="element-367">7 rate lunare</strong> pentru
                  flexibilitate maximă.
                </p>
              </div>
              <Button className="w-full text-base py-5" data-id="element-368">
                Scrie-mi pe WhatsApp pentru detalii!
              </Button>
            </div>
          </div>
        </motion.div>
        {/* Urgency note */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-369">
          <div className="inline-flex items-center gap-3 bg-red-500/10 border border-red-500/20 px-6 py-3 rounded-full" data-id="element-370">
            <span className="relative flex h-3 w-3" data-id="element-371">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-372"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-373"></span>
            </span>
            <p className="font-sans text-white text-xl" data-id="element-374">
              <strong className="text-red-400" data-id="element-375">Locurile sunt limitate.</strong>{' '}
              Primul modul începe pe 13-14 Iunie 2026.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};